<template>
  <v-menu offset-y content-class="white">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon class="mr-2" v-on="on" v-bind="attrs" @click="SET_DIALOG(DIALOG_TYPES.LISTADO_NOTIFICACIONES)">
        <v-icon color="secondary">mdi-bell</v-icon>
      </v-btn>
    </template>
  </v-menu>
</template>

<script>
import { DIALOG_TYPES } from '@src/plugins/dialog-types'
import { mapMutations } from 'vuex'
import NotificationsList from './NotificationsList.vue'

export default {
  components: { NotificationsList },

  data() {
    return {
      DIALOG_TYPES,
    }
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
  },
}
</script>
